import React from "react";
import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./translatableText.module.css";
import { useTranslatableText } from "./useTranslatableText";
import TranslateButton from "./translateButton";

interface TranslatableTextProps {
  text: string;
  className?: string;
  translatable?: boolean;
  buttonPlacement?: "inline" | "none";
}

const TranslatableText = ({
  text,
  className,
  translatable = true,
  buttonPlacement = "inline",
}: TranslatableTextProps) => {
  const {
    displayText,
    isTranslated,
    isLoading,
    handleTranslate,
    showTranslateButton,
    buttonLabel,
    hasContent,
  } = useTranslatableText(text, translatable);

  if (!hasContent) {
    return null;
  }

  const showButton = showTranslateButton && buttonPlacement === "inline";

  return (
    <div className={styles.container}>
      <div className={styles.contentRow}>
        <p className={className}>{displayText}</p>
        {showButton && (
          <TranslateButton
            label={buttonLabel}
            isTranslated={isTranslated}
            isLoading={isLoading}
            onClick={handleTranslate}
            ariaLabel={
              isTranslated ? t("SHOW_ORIGINAL") : t("TRANSLATE_TO_MY_LANGUAGE")
            }
            variant="inline"
          />
        )}
      </div>
    </div>
  );
};

export default TranslatableText;
